import { SET_ACTIVITIES } from './activities';
import { getCallConsoleItem, callListUrl, CALL_LISTS_SHOW } from 'bundles/connect/helpers/prospect_api';

export const SET_CALL_CONSOLE_DATA = 'SET_CALL_CONSOLE_DATA';
export const UPDATE_CALL_CONSOLE_DATA = 'UPDATE_CALL_CONSOLE_DATA';
export const SET_CALL_CONSOLE_VERIFIED_OWNER = 'SET_CALL_CONSOLE_VERIFIED_OWNER';
export const SET_CALL_CONSOLE_OWNER_CONTACT_METHOD_SCORE = 'SET_CALL_CONSOLE_OWNER_CONTACT_METHOD_SCORE';
export const DELETE_CALL_CONSOLE_OWNERSHIP = 'DELETE_CALL_CONSOLE_OWNERSHIP';
export const ADD_CALL_CONSOLE_OWNERSHIP = 'ADD_CALL_CONSOLE_OWNERSHIP';
export const UPDATE_CALL_CONSOLE_CONTACT = 'UPDATE_CALL_CONSOLE_CONTACT';
export const SET_CALL_LIST_ITEM_ID = 'SET_CALL_LIST_ITEM_ID';

export function setIndex(url) {
  return async (dispatch) => {
    return await getCallConsoleItem(url).then((data) => {
      dispatch({
        type: SET_CALL_CONSOLE_DATA,
        payload: { aiRelatedCompanies: [], owners: null, connectPropertyId: data.recordId, ...data }
      });
      dispatch({ type: SET_ACTIVITIES, payload: data.activities });
      window.history.replaceState(
        {}, '', `${callListUrl(CALL_LISTS_SHOW, data.callList.id)}/call_console?index=${data.index}`
      );
    });
  };
}

export function setCallListItemId(id) {
  return {
    type: SET_CALL_LIST_ITEM_ID,
    payload: id
  };
}
